import { BaseApi, HttpMethodEnum } from '../BaseApi/BaseApi';
import {
  IPatientProgramModel,
  PatientProgram,
} from '../../entities/PatientProgram/PatientProgram.ts';
import Utils from '../../helpers/utils.ts';

export class PatientProgramApi extends BaseApi {
  private static baseApiUrl: string = `${BaseApi.apiUrl}/Patients`;

  public static apiUrls = {
    getProgram: `${PatientProgramApi.baseApiUrl}/:id/Program`,
    setEventDate: `${PatientProgramApi.baseApiUrl}/:id/Program/EventDate`,
  };

  public static async getPatientProgram(
    patientId: number,
  ): Promise<PatientProgram | null> {
    const result = await this.sendApiRequest<IPatientProgramModel | null>({
      method: HttpMethodEnum.GET,
      path: this.apiUrls.getProgram,
      data: undefined,
      id: patientId.toString(),
    });
    return result ? new PatientProgram(result) : null;
  }

  public static async setEventDate(
    patientId: number,
    eventDate: Date,
  ): Promise<PatientProgram> {
    const result = await this.sendApiRequest<IPatientProgramModel>({
      method: HttpMethodEnum.PUT,
      path: this.apiUrls.setEventDate,
      data: { eventDate: Utils.formatLocalDateToYYYYMMDD(eventDate) },
      id: patientId.toString(),
    });
    return new PatientProgram(result);
  }
}
